import commonResource from '@/resources/common'

const AppErrorPlugin = {
  install (Vue) {
    Vue.prototype.$handleGeneralError = (error, dialogRef) => {
      Vue.logger.error(error)
      if (dialogRef && dialogRef.showMessageOkDialog) {
        dialogRef.showMessageOkDialog(commonResource.generalErrorMessage)
      }
    }
  }
}

export default AppErrorPlugin
